import { useParams, useNavigate } from 'react-router-dom';
import { useGetAssessment } from './properties/useGetAssessment';
import { useGetExamQuestions } from './properties/useGetExamQuestions';
import moment from 'moment';
import { Button, Form, Modal } from 'react-bootstrap';
import { useState, useRef, useEffect } from 'react';
import { useGetCoursesName } from "./properties/useGetCoursesName";
import Webcam from "react-webcam";
import { FaVideo } from 'react-icons/fa';
import { current } from '@reduxjs/toolkit';
import { useDeleteSPFileMutation, useUploadDocument } from '../../../services/data/sharepoint';
import { useCreateEntityChecklistItemMutation } from '../document-checklist/services/entityChecklistItemsApi';
import { v4 as uuidv4 } from 'uuid';
import { useGetExamMarks } from './properties/useGetExamMarks';
import { useGetExaminerScore } from './properties/useGetExaminerScore';
import { useDeleteMutation } from '../../../services/data/tableDataApi';
import { useAuth } from '../../../../modules/auth';

export const ExamDetailsComponent = () => {
    const { examId } = useParams<{ examId: string }>();
    const { examMarksId } = useGetExamMarks(examId || '');
    const { assessments } = useGetAssessment();
    const { questionsCount } = useGetExamQuestions(examId || '');
    const [acknowledged, setAcknowledged] = useState(false);
    const { getCourseName } = useGetCoursesName();
    const navigate = useNavigate();
    const exam = assessments.find(assessment => assessment.assessmentId === examId);
    const [examination, setExam] = useState<any>(null);
    const [capturedFace, setCapturedFace] = useState<string | null>(null);
    const [capturedID, setCapturedID] = useState<string | null>(null);
    const webcamRef = useRef<Webcam>(null);
    const [capturingFace, setCapturingFace] = useState(false);
    const [capturingID, setCapturingID] = useState(false);
    const [step, setStep] = useState(1);
    const [showDialog, setShowDialog] = useState(false);
    const [statusMessage, setStatusMessage] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [documentUrl, setDocumentUrl] = useState<string>("");
    const { uploadDocument } = useUploadDocument();
    const [removeRecord] = useDeleteMutation();
    const [isUploading, setIsUploading] = useState(false);
    const { examinerScore } = useGetExaminerScore();
    const relativePath = `/sites/EdTech365/slcm_examinerscore/_${examinerScore}`
    const { user, siteId } = useAuth();
    const [deleteFile, { isLoading, isSuccess, isError }] = useDeleteSPFileMutation()
    const [error, setError] = useState()

    if (!exam) {
        return <div>Loading...</div>;
    }
    function transformUrl(relativePath: string) {
        return relativePath.replace(/([a-f0-9-]{36})/i, match => match.replace(/-/g, "").toUpperCase());
    }

    const transformedExaminerScore = examinerScore ? transformUrl(relativePath) : null;
    const handleUpload = (file: File): Promise<string> => {
        if (!transformedExaminerScore)
            return Promise.reject('Cant upload this document.');
        setIsUploading(true);
        console.log("file", file);
        return uploadDocument({ file, folderRelativeUrl: transformedExaminerScore })
            .then((document) => {
                setDocumentUrl(document.serverRelativeUrl)
                return Promise.resolve(document.serverAbsoluteUrl)
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            }).finally(() => setIsUploading(false));
    };

    const captureImage = async (isID = false) => {
        if (webcamRef.current) {
            const imageSrc = webcamRef.current.getScreenshot();
            console.log("Captured Image (Base64):", imageSrc);

            if (imageSrc) {
                const file = base64ToFile(imageSrc, `${uuidv4()}.png`);
                if (isID) {
                    setCapturedID(imageSrc);
                    setCapturingID(false);
                } else {
                    setCapturedFace(imageSrc);
                    setCapturingFace(false);
                }
                handleUpload(file)
                    .then((url) => console.log("Upload successful:", url))
                    .catch((err) => console.error("Upload failed:", err));
            }
        }
    };

    const base64ToFile = (base64String: string, filename: string): File => {
        const arr = base64String.split(",");
        const mime = arr[0].match(/:(.*?);/)?.[1] || "image/png";
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    };


    const deleteDocument = (relativeUrl: string) => {
        deleteFile(relativeUrl)
            .unwrap()
            .catch((error) => {
                setError(error)
            })
    }
    const handleRetake = (isID = false) => {
        if (isID) {
            deleteDocument(documentUrl);
            setCapturedID(null);
            setCapturingID(true);
        } else {
            deleteDocument(documentUrl);
            setCapturedFace(null);
            setCapturingFace(true);
        }
    };
    const currentTime = moment();
    const startTime = moment(exam.starttime);
    const endTime = moment(exam.endtime);
    const isTimeValid = currentTime.isBetween(startTime, endTime);
    const examDuration = moment(exam.endtime).diff(moment(exam.starttime), 'minutes');
    const durationHours = Math.floor(examDuration / 60);
    const durationMinutes = examDuration % 60;
    let formattedDuration = `${durationHours} hrs : ${durationMinutes.toString().padStart(2, '0')} mins`;
    const handleAcknowledgmentChange = () => {
        setAcknowledged(!acknowledged);
    };
    const handleStartExamClick = () => {
        if (!acknowledged) {
            alert('Please acknowledge the exam instructions before starting the exam.');
            return;
        }
        setShowDialog(true);
    };
    const handleConfirmStartExam = () => {
        setShowDialog(false);
        navigate(`/startexam(${examId})`);
    };
    const handleAbortExamClick = () => {
        window.history.back();
    };

    return (
        <div className="container"
            style={{
                height: 'auto',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            {step === 1 ? (
                <div style={{ position: "relative", minHeight: "65vh" }}>
                    <h1 className="text-center" style={{ backgroundColor: "lightgrey" }}>Exam Verification Process</h1>
                    <p className="fw-bold mt-5" style={{ color: "red", fontSize: "1.2rem", textAlign: "left" }}>
                        Follow these instructions:
                    </p>
                    <ul>
                        <li>Ensure proper lighting for a clear image.</li>
                        <li>Look directly at the camera without obstructions.</li>
                        <li>Hold your ID card close and make sure details are visible.</li>
                        <li>Ensure that the captured photo and ID card belong to the same individual.</li>
                        <li>Any discrepancies or irregularities in the photo verification process may result in exam disqualification or further consequences.</li>
                    </ul>
                    <hr className="my-3" />
                    <div className="d-flex flex-column flex-md-row justify-content-center align-items-center mt-4 mb-2">
                        <div className="d-flex flex-column align-items-center mx-5 my-10">
                            {!capturingFace && !capturedFace && (
                                <Button onClick={() => setCapturingFace(true)}>Capture Face</Button>
                            )}
                            {capturedFace && (
                                <>
                                    <img src={capturedFace} alt="Captured Face" width="215" className="mt-2" />
                                    <Button variant="warning" className="mt-2" onClick={() => handleRetake(false)}>Retake Photo</Button>
                                </>
                            )}
                        </div>
                        <div className="d-flex flex-column align-items-center mx-5 my-10">
                            {!capturingID && !capturedID && (
                                <Button onClick={() => setCapturingID(true)}>Capture ID</Button>
                            )}
                            {capturedID && (
                                <>
                                    <img
                                        src={capturedID}
                                        alt="Captured ID"
                                        style={{ width: "250px", height: "160px", objectFit: "cover", borderRadius: "5px" }}
                                        className="mt-2"
                                    />
                                    <Button variant="warning" className="mt-2" onClick={() => handleRetake(true)}>Retake Photo</Button>
                                </>
                            )}
                        </div>
                    </div>

                    {capturingFace || capturingID ? (
                        <div className="d-flex flex-column align-items-center mt-4">
                            <Webcam
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                width={capturingFace ? 300 : 320}
                                height={capturingFace ? 300 : 200}
                                style={{ borderRadius: capturingFace ? "50%" : "5px", objectFit: "cover" }}
                            />
                            <Button className="mt-3" onClick={() => captureImage(capturingID)}>Take Photo</Button>
                        </div>
                    ) : null}

                    <div className="d-flex justify-content-end mt-10">
                        <Button
                            variant="danger"
                            onClick={handleAbortExamClick}
                            style={{ marginRight: '10px' }}
                        >
                            Abort Exam
                        </Button>
                        <Button
                            variant={capturedFace && capturedID ? "primary" : "secondary"}
                            onClick={() => setStep(2)}
                            disabled={!capturedFace || !capturedID}
                        >
                            Next
                        </Button>
                    </div>
                </div>
            ) : (
                <div>
                    <h1 className="text-center" style={{ backgroundColor: 'lightgrey' }}>Exam Details</h1>
                    <div className="card p-4 mt-4 d-flex flex-column flex-md-row">

                        <div className="col-md-7 mb-4 mb-md-0 pr-md-4" style={{ fontSize: '1.25rem' }}>
                            <h2 style={{ textAlign: 'center', marginBottom: '15px' }}>{exam.name}</h2>
                            <div className="mb-2">
                                <strong style={{ minWidth: '200px', display: 'inline-block' }}>Course:</strong>
                                <span>{getCourseName(exam.courseId || '')}</span>
                            </div>
                            <div className="mb-2">
                                <strong style={{ minWidth: '200px', display: 'inline-block' }}>Starting on:</strong>
                                <span>{moment(exam.starttime).format('DD-MM-YYYY HH:mm')}</span>
                            </div>
                            <div className="mb-2">
                                <strong style={{ minWidth: '200px', display: 'inline-block' }}>Expiring on:</strong>
                                <span>{moment(exam.endtime).format('DD-MM-YYYY HH:mm')}</span>
                            </div>
                            <div className="mb-2">
                                <strong style={{ minWidth: '200px', display: 'inline-block' }}>Total Questions:</strong>
                                <span>{questionsCount}</span>
                            </div>
                            <div className="mb-2">
                                <strong style={{ minWidth: '200px', display: 'inline-block' }}>Total Marks:</strong>
                                <span>{exam.totalMarks}</span>
                            </div>
                            <div className="mb-2">
                                <strong style={{ minWidth: '200px', display: 'inline-block' }}>Exam Duration:</strong>
                                <span>{formattedDuration}</span>
                            </div>
                        </div>


                        <div
                            className="overflow-auto"
                            style={{
                                backgroundColor: '#f7f7f7',
                                padding: '15px',
                                overflowY: 'auto',
                                minHeight: '200px',
                                maxHeight: '605px',
                                borderRadius: '10px',
                                flex: 1,
                                resize: 'vertical', 
                                overflow: 'auto',   
                            }}
                        >
                            <h4>Kindly Read the following Instructions:</h4>
                            <ul> {(exam.instruction ? exam.instruction.split('\n') : ['No instructions provided']).map((line, index) => (
                                <li key={index}>{line}</li>
                            ))}</ul>
                            <Form.Group controlId="formBasicCheckbox" className="mt-4">
                                <Form.Check
                                    type="checkbox"
                                    label="I have read and agree to the exam instructions"
                                    checked={acknowledged}
                                    onChange={handleAcknowledgmentChange}
                                    style={{ borderColor: '#000' }}
                                />
                            </Form.Group>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="secondary" style={{ marginRight: '10px' }} onClick={() => setStep(1)}>Back</Button>
                        {isTimeValid && acknowledged ? (
                            <Button
                                variant='primary'
                                className="ml-3"
                                onClick={handleStartExamClick}
                            >
                                Continue
                            </Button>
                        ) : (
                            <Button
                                style={{ backgroundColor: 'grey', borderColor: 'grey', color: 'white', marginRight: '10px' }}
                                className="ml-3"
                                disabled
                            >
                                Continue
                            </Button>
                        )}
                    </div>

                    <Modal show={showDialog} onHide={() => setShowDialog(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <a href="https://teams.microsoft.com/v2/" target="_blank" rel="noopener noreferrer"
                                    style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '10px', color: '#0a66c2' }}>
                                    <FaVideo size={24} />
                                    Join Online Meeting
                                </a>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>You must join the online meeting before starting your exam.</p>
                        </Modal.Body>
                        <Modal.Footer className="d-flex flex-row align-items-center">
                            <p className="mb-2 pr-5 font-extrabold text-gray-800">Already Joined?</p>
                            <Button variant="primary" onClick={handleConfirmStartExam}>Start Exam</Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            )}
        </div>
    );
};